// extracted by mini-css-extract-plugin
export default {"contacts-container":"Contacts_contacts-container__-0RfH","whats-next":"Contacts_whats-next__yim6K","scroll-wrapper":"Contacts_scroll-wrapper__ckm3m"};